module.exports = __webpack_public_path__ + "img/page-30.8c39418c.jpg";